import { render, staticRenderFns } from "./shuoli.vue?vue&type=template&id=3e8bb177&scoped=true&"
import script from "./shuoli.vue?vue&type=script&lang=js&"
export * from "./shuoli.vue?vue&type=script&lang=js&"
import style0 from "./shuoli.vue?vue&type=style&index=0&id=3e8bb177&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8bb177",
  null
  
)

export default component.exports